import Api from "./base/api-base";

export default class AnalysisApi {
  info(start_date_from, start_date_to, end_date_from, end_date_to) {
    return Api.link.get({
      links: [
        {endpoint: Api.endpoint.analysis},
        {endpoint: "/start_from", id: start_date_from || "-"},
        {endpoint: "/start_to", id: start_date_to || "-"},
        {endpoint: "/end_from", id: end_date_from || "-"},
        {endpoint: "/end_to", id: end_date_to || "-"}
      ]
    });
  }
}
